import React from 'react';
import styled from '@emotion/styled';
import { Colors } from '@zapier/design-system';
import { Tags } from 'data/SingleArticle/types';

type Props = {
  tags: Tags;
  type: string;
};

export const Pills = ({ tags, type }: Props) => {
  return (
    <Outer>
      <Heading>{type}</Heading>
      <ContentWrapper>
        {tags.map((tag, index) => (
          <Content key={index}>{tag}</Content>
        ))}
      </ContentWrapper>
    </Outer>
  );
};

const Outer = styled.div`
  max-width: 600px;
`;

const Heading = styled.strong`
  color: ${Colors.grey900};
  display: inline;
  float: left;
  font-size: 14px;
  font-weight: bold;
  padding-top: 15px;
  margin-right: 10px;
  text-transform: uppercase;
`;

const ContentWrapper = styled.ul`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin: 0;
`;

const Content = styled.li`
  border: 1px solid ${Colors.grey900};
  border-radius: 10px;
  color: ${Colors.grey900};
  font-size: 14px;
  padding: 4px 15px;
  margin: 10px 10px 0 0;
`;
